<script setup lang="ts">
import { useOnTimezoneChange } from '@entities/viewer'

import SectionExtraRatesBody from './extra-rates/SectionExtraRatesBody.vue'
import { useExtraRatesApi } from '../api/demo-slots/extra-rates.hook'

defineOptions({
  name: 'DemosExtraRatesPage',
})

useOnTimezoneChange(() => {
  void useExtraRatesApi()
})
</script>

<template>
  <SectionExtraRatesBody />
</template>
